/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSelector } from '@reduxjs/toolkit';
import { getState } from './rootState';
export const getLoadingStatus = createSelector(getState, ({ loadingStatus }) => loadingStatus);
export const getListFetchingError = createSelector(getState, ({ listFetchingError }) => listFetchingError);
export const getDataCollection = createSelector(getState, ({ dataCollection }) => dataCollection);
export const getDatasetsCollection = createSelector(getState, ({ datasetsCollection }) => datasetsCollection);
export const getProviders = createSelector(getDatasetsCollection, (collection) => Object
    .entries(collection)
    .filter((entry) => Object.values(entry[1]).length > 0)
    .map((entry) => entry[0]));
export const getErrorCollection = createSelector(getState, ({ errorCollection }) => errorCollection);
